import React, { useState } from 'react';

import { styled } from '@mui/material/styles';

import LessonsListFilters from './lessons_list_filters';
import _ from 'lodash';

import { Paper, Button, useTheme, useMediaQuery } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import FilterAltIcon from '@mui/icons-material/FilterAlt';


const PREFIX = 'SearchAndFilter';

const classes = {
    sectionDesktop: `${PREFIX}-sectionDesktop`,
    sectionMobile: `${PREFIX}-sectionMobile`,
    paper: `${PREFIX}-paper`,
    new_lesson: `${PREFIX}-new_lesson`,
    filter_button: `${PREFIX}-filter_button`,
    text: `${PREFIX}-text`,
    new_lesson_button: `${PREFIX}-new_lesson_button`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.sectionDesktop}`]: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
        },
    },

    [`& .${classes.sectionMobile}`]: {
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },

    [`& .${classes.paper}`]: {
        minWidth: '28vw',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        overflowX: 'hidden',
    },

    [`& .${classes.new_lesson}`]: {
        padding: '0.5rem',
        display: 'flex'
    },

    [`& .${classes.filter_button}`]: {
        backgroundColor: '#0B7CB0',
        color: 'white',
        minWidth: '20vw',
        height: '2.5rem',
        padding: '0.5rem',
        minWidth: '5vw',
        margin: 'auto',
    },

    [`& .${classes.text}`]: {
        color: 'white',
        textDecoration: 'none',
        padding: theme.spacing(0, 1.5),
    },

    [`& .${classes.new_lesson_button}`]: {
        backgroundColor: '#0B7CB0',
        color: 'white',
        minWidth: '20vw',
        height: '2.5rem',
        // justifyContent: "flex-start"
    }
}));

const SearchAndFilter = props => {
    let { toggleLessonSearch, updateLLViewSettings, ll_settings } = props;


    const [showFilters, setShowFilters] = useState(false);
    const toggleShowFilters = (value=showFilters) => {
        setShowFilters(!value)
    }

    const [anchorEl, setAnchorEl] = React.useState(null);

    const theme = useTheme();
    let mode = useMediaQuery(theme.breakpoints.up('sm')) ? 'desktop':'mobile'


    return (
        <Root>
            {(mode === 'desktop') && (
                <Paper className={classes.paper}>
                    <div className={classes.new_lesson}>
                        <Button 
                            variant="contained" 
                            className={classes.new_lesson_button} onClick={() => toggleLessonSearch(true)}>
                            <SearchIcon />
                            Search
                        </Button>
                        <Button 
                            variant="contained"
                            className={classes.filter_button} 
                            onClick={(event) => {
                                toggleShowFilters()
                                setAnchorEl(event.currentTarget)
                            }}
                            size='small'
                        >
                            <FilterListIcon />
                            Filter
                        </Button>
                        {showFilters && (
                            <LessonsListFilters 
                                showFilters={showFilters}
                                toggleShowFilters={toggleShowFilters}
                                ll_settings={ll_settings} 
                                updateLLViewSettings={updateLLViewSettings}
                                anchorEl={anchorEl}                        
                            />
                        )}
                    </div>                
                </Paper>
            )}
            {(mode === 'mobile') && (
                <div style={{display: 'flex'}}>
                        <div 
                            onClick={(event) => {
                                toggleShowFilters()
                                setAnchorEl(event.currentTarget)
                            }}

                            className={classes.text}
                        >
                            <FilterAltIcon />
                        </div>
                        <div 
                            className={classes.text}
                            onClick={() => toggleLessonSearch(true)}
                        >
                            <SearchIcon />
                        </div>
                        {showFilters && (
                            <LessonsListFilters 
                                showFilters={showFilters}
                                toggleShowFilters={toggleShowFilters}
                                ll_settings={ll_settings} 
                                updateLLViewSettings={updateLLViewSettings}
                                anchorEl={anchorEl}                        
                            />
                        )}
                </div>                
            )}
        </Root>
    );

}


export default SearchAndFilter;